module.exports = __webpack_public_path__ + "images/lhdn.gif";


//////////////////
// WEBPACK FOOTER
// ./images/lhdn.gif
// module id = 1119
// module chunks = 1